import SelectField from 'components/forms/selectField/SelectField';
import { useWatch } from 'react-hook-form';
import {
  GetIntegrationAgencySettingsResponseTO,
  RemoteLockAccessibleType,
} from 'models/InternalIntegrationSetting';
import { NO_LOCK_OPTION_VALUE } from './useLockAssignment';
import useDeleteLockAssignment from './useDeleteLockAssignment';
import usePostLockAssignment from './usePostLockAssignment';

const LockSelect = ({
  integrationName,
  options,
  propertyName,
  integrationAgencySettings,
  propertyUid,
}: {
  integrationName: string;
  options: {
    label: string;
    value: string;
    accessibleType?: RemoteLockAccessibleType;
  }[];
  propertyName: string;
  integrationAgencySettings: GetIntegrationAgencySettingsResponseTO;
  propertyUid: string;
}) => {
  const currentLockId = useWatch({ name: 'lockId' });

  const { mutate: deleteLockAssignment, isLoading: isDeletingLockAssignment } =
    useDeleteLockAssignment();
  const { mutate: updateLockAssignment, isLoading: isUpdatingLockAssignment } =
    usePostLockAssignment();

  const isLoading = isDeletingLockAssignment || isUpdatingLockAssignment;

  return (
    <SelectField
      name="lockId"
      options={options}
      colSmInput={12}
      data-testid="lock-assignment-select"
      disabled={isLoading}
      className={
        currentLockId === NO_LOCK_OPTION_VALUE ? 'no-lock-option-selected' : ''
      }
      onChangeHandler={(e) => {
        const { value } = e.target as HTMLSelectElement;

        const lockName = options.find(
          (option) => option.value === value,
        )?.label;

        const accessibleType = options.find(
          (option) => option.value === value,
        )?.accessibleType;

        if (value === NO_LOCK_OPTION_VALUE) {
          deleteLockAssignment({
            enumId: integrationAgencySettings.enumId,
            propertyUid,
            propertyName,
            integrationName,
          });
        } else {
          updateLockAssignment({
            enumId: integrationAgencySettings.enumId,
            propertyUid,
            lockId: value,
            integrationName,
            propertyName,
            lockName: lockName!,
            accessibleType,
          });
        }
      }}
    />
  );
};

export default LockSelect;
